import * as Types from '@aeppic/types'

export function readId(identifer: Types.IdOrReference|Types.Document): string {
  if (typeof identifer === 'string') {
    return identifer
  } else {
    return identifer.id
  }
}
